import { render, staticRenderFns } from "./MerchantBusinessManagement.vue?vue&type=template&id=856bcdf6&"
import script from "./MerchantBusinessManagement.vue?vue&type=script&lang=js&"
export * from "./MerchantBusinessManagement.vue?vue&type=script&lang=js&"
import style0 from "./MerchantBusinessManagement.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports